function calculateEvaluationScore() {
	var form = jQuery(this).closest('form');
	var scoreTarget = form.find('.score-target');
	var newValue = 0;

	jQuery('select[name^="evaluation"]').each(function() {
		var value = jQuery(this).val() * jQuery(this).data('weight');
		if (!isNaN(value)) {
			newValue += value
		}
	});
	
	scoreTarget.text(newValue);
}

var calculateEvaluationScores = function(){
	jQuery('body').undelegate('select[name^="evaluation"]', 'change', calculateEvaluationScore);
	jQuery('body').delegate('select[name^="evaluation"]', 'change', calculateEvaluationScore);
}

window.calculateEvaluationScores = calculateEvaluationScores;